export default "__VITE_PUBLIC_ASSET__46379818__"